<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-search @search="updateList">
				<c-form>
					<c-form-item type="input" label="理赔项目" name="project_name"></c-form-item>
					<c-form-item type="input" label="理赔方" name="yzdw_name"></c-form-item>
					<c-form-item type="select" label="保单类型" name="bx_type_id" options="INSURANCE_TYPE"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="状态"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="claimState[data.state]" :style="{'color': claimState[data.state].color}">{{claimState[data.state].name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="协助理赔状态"
					width="110"
				>
					<template v-slot="{data}">
						<span v-if="assistClaimState[data.xzlp_state]" :style="{'color': assistClaimState[data.xzlp_state].color}">{{assistClaimState[data.xzlp_state].name}}</span>
					</template>
				</c-table-column>
					
				<c-table-column
					label="理赔项目名称"
					name="project_name"
					width="160"
				></c-table-column>
				
				<c-table-column
					label="保单类型"
					name="type_name"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="理赔方"
					name="yzdw_name"
					width="160"
				></c-table-column>
				
				<c-table-column
					label="保单金额"
					width="120"
				>
					<template v-slot="{data}">
						￥{{data.bd_money}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
					width="160"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 1 && power('3')" @click="navigateTo('/transact/claim/detail', {id: data.id}, true)">审批</c-table-button>
						<c-table-button v-else-if="data.state == 2 && power('3')" @click="navigateTo('/transact/claim/detail', {id: data.id}, true)">受理</c-table-button>
						<c-table-button v-else-if="data.xzlp_state == 1 && power('6')" @click="navigateTo('/transact/claim/detail', {id: data.id}, true)">确认</c-table-button>
						<c-table-button v-else-if="data.state == 3 && data.xzlp_state == 2 && power('6')" @click="navigateTo('/transact/claim/detail', {id: data.id}, true)">完结</c-table-button>
						<c-table-button v-else @click="navigateTo('/transact/claim/detail', {id: data.id}, true)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		props: {
			scene: String
		},
		
		computed: {
			...mapGetters(['power', 'claimState', 'assistClaimState'])
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList(data = {}) {
				if (this.scene == 'approve') {
					data.states = [1, 2, 3];
				} else {
					data.states = [4, 5];
				}
				this.$refs.table.load({
					url: '/project/bxlp/list',
					data
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>
